var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1006,
    height: 566,
    viewBox: "0 0 1006 566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1602_67)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1006,
    height: 566,
    fill: "#032330"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898.802 557.868C926.902 549.263 969.807 529.44 1015.87 502.803C1061.93 476.167 1100.51 448.867 1121.99 428.804C1165.4 389.839 1181.78 328.356 1163.53 272.864C1154.89 244.731 1135.03 201.766 1108.35 155.635C1081.67 109.503 1054.34 70.855 1034.26 49.3384C995.272 5.83994 933.814 -10.6319 878.388 7.56048C850.288 16.165 807.382 35.9884 761.321 62.6249C715.259 89.2615 676.677 116.561 655.204 136.624C611.79 175.589 595.412 237.072 613.664 292.565C622.299 320.697 642.164 363.662 668.841 409.794C695.519 455.926 722.849 494.573 742.925 516.09C781.918 559.588 843.376 576.06 898.802 557.868Z",
    fill: "url(#paint0_radial_1602_67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.602 397.615C941.869 381.039 976.932 349.346 1012.98 310.21C1049.03 271.075 1077.74 233.531 1092.27 207.987C1122.13 157.869 1119.47 94.2978 1085.53 46.7497C1068.92 22.4608 1037.17 -12.6466 997.97 -48.7509C958.774 -84.8553 921.182 -113.62 895.613 -128.188C845.443 -158.114 781.868 -155.553 734.365 -121.692C710.099 -105.116 675.035 -73.4237 638.986 -34.2878C602.937 4.84808 574.225 42.3914 559.694 67.9352C529.841 118.053 532.5 181.625 566.437 229.173C583.052 253.462 614.802 288.569 653.998 324.674C693.193 360.778 730.785 389.543 756.354 404.111C806.524 434.037 870.1 431.475 917.602 397.615Z",
    fill: "url(#paint1_radial_1602_67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.525 239.11C974.192 210.93 991.435 162.836 1005.82 107.146C1020.2 51.4555 1028.41 1.02702 1029.22 -30.7303C1032.09 -93.7248 997.121 -152.95 940.517 -180.944C912.289 -195.612 864.118 -212.867 808.342 -227.273C752.567 -241.679 702.065 -249.908 670.264 -250.744C607.183 -253.662 547.905 -218.779 519.915 -162.272C505.248 -134.092 488.005 -85.9984 473.622 -30.308C459.238 25.3825 451.035 75.811 450.222 107.568C447.347 170.563 482.32 229.788 538.924 257.782C567.151 272.45 615.323 289.705 671.098 304.111C726.874 318.516 777.376 326.746 809.176 327.582C872.257 330.499 931.535 295.617 959.525 239.11Z",
    fill: "url(#paint2_radial_1602_67)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.4011 113.848C59.4952 123.062 17.0313 143.814 -28.4394 171.447C-73.9102 199.08 -111.889 227.213 -132.921 247.738C-175.476 287.639 -190.512 349.464 -171.057 404.546C-161.811 432.484 -141.016 475.006 -113.341 520.546C-85.6658 566.087 -57.5013 604.131 -36.9616 625.205C2.96883 667.845 64.7707 682.975 119.788 663.581C147.694 654.366 190.158 633.614 235.628 605.981C281.099 578.348 319.078 550.216 340.11 529.69C382.665 489.789 397.701 427.964 378.246 372.882C369 344.944 348.205 302.422 320.53 256.882C292.855 211.341 264.69 173.298 244.151 152.223C204.22 109.584 142.418 94.4533 87.4011 113.848Z",
    fill: "url(#paint3_radial_1602_67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5793 279.231C73.8793 295.154 37.9832 325.9 0.903362 364.06C-36.1765 402.221 -65.8788 438.986 -81.0858 464.133C-112.265 513.437 -111.302 577.057 -78.6444 625.493C-62.6829 650.216 -31.8806 686.158 6.33853 723.294C44.5577 760.431 81.3691 790.188 106.541 805.433C155.895 836.686 219.516 835.82 267.904 803.238C292.605 787.315 328.501 756.569 365.58 718.408C402.66 680.247 432.363 643.483 447.57 618.336C478.748 569.031 477.786 505.412 445.128 456.976C429.167 432.252 398.364 396.311 360.145 359.174C321.926 322.038 285.115 292.28 259.943 277.036C210.589 245.783 146.968 246.648 98.5793 279.231Z",
    fill: "url(#paint4_radial_1602_67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4977 438.696C27.7894 466.853 10.4764 514.922 -3.98873 570.591C-18.4539 626.261 -26.7313 676.677 -27.591 708.433C-30.5581 771.423 4.32778 830.699 60.8908 858.777C89.097 873.486 137.243 890.812 192.997 905.299C248.752 919.786 299.242 928.09 331.041 928.973C394.117 931.983 453.447 897.187 481.519 840.721C496.228 812.563 513.541 764.494 528.006 708.825C542.471 653.156 550.748 602.739 551.608 570.983C554.575 507.993 519.689 448.717 463.126 420.64C434.92 405.93 386.774 388.604 331.02 374.117C275.265 359.63 224.775 351.326 192.976 350.444C129.9 347.434 70.5704 382.229 42.4977 438.696Z",
    fill: "url(#paint5_radial_1602_67)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1602_67",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1085.77 116.587) rotate(138.99) scale(517.154 597.621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#02141C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#032330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073F56"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1602_67",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(964.793 -79.3112) rotate(121.679) scale(517.154 597.621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#02141C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#032330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073F56"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1602_67",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(761.131 -239.466) rotate(93.5113) scale(559.037 646.021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#02141C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#032330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073F56"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1602_67",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-89.9154 559.094) rotate(-42.2576) scale(517.154 597.621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#02141C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#032330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073F56"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1602_67",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.689 754.729) rotate(-56.7934) scale(517.154 597.621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#02141C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#032330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073F56"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1602_67",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.19 917.562) rotate(-86.4048) scale(559.037 646.021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#02141C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#032330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073F56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1602_67"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1006,
    height: 566,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.595e8f17cf40dfb411708a40fc01f8c4.svg";
export { ForwardRef as ReactComponent };